import Api from '@/api/Api'
import store from '../store'

export default {
  async getSerialList (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('inventory/serial-numbers', { params }))
  },

  async getSerialLatestCode (params) {
    return store.dispatch('checkResponseApi', await Api().get('inventory/serial-numbers/latest-code', { params }))
  },

  async getSerialSingle (id) {
    return store.dispatch('checkResponseApi', await Api().get(`inventory/serial-numbers/${id}`))
  },

  async createSerial (data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('inventory/serial-numbers', data, options))
  },

  async updateSerial (id, data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`inventory/serial-numbers/${id}`, data, options))
  },

  async updateSerialStatus (id, data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`inventory/serial-numbers/${id}/status`, data, options))
  },

  async deleteSerial (id) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().delete(`inventory/serial-numbers/${id}`))
  },
}



// WEBPACK FOOTER //
// ./src/api/SerialService.js